export default "__VITE_ASSET__C_ldD4cf__"